/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const UserBlueIcon: React.SFC = () => {
    return (
        <svg width="18" height="22" viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg">
            <title>Nav / icon / user</title>
            <g stroke="#555A77" strokeWidth="2" fill="none" fillRule="evenodd">
                <circle cx="9" cy="5" r="4" />
                <path d="M9 20.07c1.265 0 2.408.154 4.083.484 2.347.463 2.755.52 3.285.407.437-.093.632-.417.632-1.568C17 15.326 13.433 12 9 12s-8 3.326-8 7.392c0 1.15.195 1.475.632 1.57.53.113.938.055 3.285-.408 1.675-.33 2.818-.483 4.083-.483z" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/User/UserBlue.tsx